// extracted by mini-css-extract-plugin
export default {"menuItemWrapper":"fGC5X_","twoColumnsWrapper":"NDaRgI","mobileOnly":"gLGXIe","menuItemsDropdown":"NOCkYa","includeToMenuItemsDropdown":"iVUknL"};